import React, { useContext, useEffect, useRef, useState } from "react";
import Form from "react-bootstrap/Form";
import "./Track.css";
import {
  Button,
  Col,
  Container,
  Row,
  Table,
  Image,
  Modal,
  Alert,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import asc from "../../assets/images/asc.png";
import desc from "../../assets/images/desc.png";
import arrow from "../../assets/images/arrow.svg";
import synced from "../../assets/images/syncCompletedForTables.svg";
import reverseArrow from "../../assets/images/reverseArrow.svg";
import syncIconForTable from "../../assets/images/syncIconForTable.svg";
import Loader from "../common/Loader";
import { formatDate, groupBy } from "../common/helper";
import Pagination from "../common/Pagination/Pagination";
import SignaturePad from "react-signature-canvas";
import { addSignature } from "../../service/signatureService";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import {
  getLoaderToastSettings,
  getLoaderToastMessage,
  getToastSettings,
} from "../common/ToastManager";
import { UserContext } from "../../App";

function Track(props) {
  useEffect(() => {
    props.setTab("track");
  }, [props]);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [washList, setWashList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [washInventoryList, setWashInventoryList] = useState([]);
  const [vehicleWashList, setVehicleWashList] = useState([]);
  const [completeVehicleWashList, setCompleteVehicleWashList] = useState([]);
  const [showWashInventoryList, setShowWashInventoryList] = useState(false);
  const [customerName, setCustomerName] = useState("");
  //for pagination
  const itemsPerpage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const [endOffset, setEndOffset] = useState(itemsPerpage);
  const [isLoadPagination, setIsLoadPagination] = useState(true);
  const [currentWashList, setCurrentWashList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [sortingType, setSortingType] = useState("accDateASC");
  const [accountSummary, setAccountSummary] = useState([]);

  //states for handling the modal
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  // canvas created for draw signature
  const canvas = useRef();
  // state variables for siganture capturing feature
  // state which stores canvas data
  const [signatureCaptured, setSignatureCaptured] = useState(null);
  // state for checking is fleet manager available if its true then only we show signature option
  const [fleetManagerAvailable, setFleetManagerAvailable] = useState(false);
  // state for checking the signature modal is submittable if it is true then the curresponding useeffect will trigger
  const [isSubmittable, setIsSubmittable] = useState(false);
  // state for checking the signature modal is submittable if it is true then the curresponding useeffect will trigger
  const [selectedObj, setSelectedObj] = useState({});
  // state for showing approve button
  const [showApproveButton, setShowApprovedButton] = useState(false);
  // state for disable/enable approve button
  const [isDisabledApproveButton, setisDisabledApprovedButton] = useState(true);
  //state for storing name
  const [name, setName] = useState("");
  const [isViewAllToggled, setIsViewAllToggled] = useState(false);
  const user = useContext(UserContext);
  const currentUTCDate = new Date().toISOString().split("T")[0];

  const toastLoader = (toastMessage) =>
    toast.loading(toastMessage, getLoaderToastSettings());
  const toastLoaderUpdate = (id, toastMessage, type) =>
    toast.update(id, getLoaderToastMessage(toastMessage, type));

  useEffect(async () => {
    if (fleetManagerAvailable && signatureCaptured !== null && isSubmittable) {
      if (canvas.current.isEmpty() || name === "") {
        let toastId = toastLoader("Please wait...");
        toastLoaderUpdate(toastId, "Name and Signature Required", "error");
      } else {
        props.createSignature({
          leadId: selectedObj.leadId,
          accountId: selectedObj.accountId,
          date: moment(new Date(new Date()))
            .utc()
            .format("YYYY-MM-DD HH:mm:ss"),
          signature: signatureCaptured,
          approved: 1,
          isFleetManagerAvailable: 1,
          ids: vehicleWashList
            .map((obj) => obj.id)
            .filter((id) => id !== undefined),
          uuids: vehicleWashList.map((obj) => obj.uuid),
          approvedByName: name,
          locationNumber: selectedObj.locationNumber,
        });
        setName("");
      }
    }
    if (!fleetManagerAvailable && isSubmittable) {
      props.createSignature({
        leadId: selectedObj.leadId,
        accountId: selectedObj.accountId,
        date: moment(new Date(new Date())).utc().format("YYYY-MM-DD HH:mm:ss"),
        signature: null,
        approved: 1,
        isFleetManagerAvailable: 0,
        ids: vehicleWashList
          .map((obj) => obj.id)
          .filter((id) => id !== undefined),
        uuids: vehicleWashList.map((obj) => obj.uuid),
        approvedByName: selectedObj.leadName,
        locationNumber: selectedObj.locationNumber,
      });
      setName("");
    }
    setIsSubmittable(false);
  }, [signatureCaptured, fleetManagerAvailable, isSubmittable]);

  //functions for handling the modal
  const handleCloseSignatureModal = async () => {
    setShowSignatureModal(false);
  };
  const handleShowSignatureModal = () => {
    setFleetManagerAvailable(false);
    setShowSignatureModal(true);
  };

  // function for clearing the signature canvas
  const clear = () => {
    canvas.current.clear();
    setSignatureCaptured(null);
  };
  // function trigger when we click save in signature model
  const save = () => {
    if (fleetManagerAvailable) {
      setSignatureCaptured(
        canvas.current.getTrimmedCanvas().toDataURL("image/png"),
      );
    }
    setIsSubmittable(true);
    handleCloseSignatureModal();
  };

  useEffect(() => {
    setAccountSummary(props.accountSummary);
  }, [props.accountSummary]);

  useEffect(() => {
    // fetchAllWashInventories();
    setWashInventoryList(props.washInventoryList);
  }, [props.washInventoryList]);

  useEffect(() => {
    getWashList();
  }, [washInventoryList]);

  useEffect(() => {
    filterWashList();
  }, [isViewAllToggled]);

  function groupByLocationNumber(data) {
    const groupedData = data.reduce((acc, item) => {
      const index = acc.findIndex(
        (arr) => arr[0].locationNumber === item.locationNumber,
      );
      if (index === -1) {
        acc.push([item]);
      } else {
        acc[index].push(item);
      }
      return acc;
    }, []);
    return groupedData;
  }

  function getAccountName(accountId, locationNumber) {
    const account = accountSummary.find(
      (account) => account.accountId === accountId,
    );
    if (account) {
      if (account.locations.length > 1) {
        const location = account.locations.find(
          (loc) => loc.locationNumber === locationNumber,
        );
        if (location) {
          return account.name + " - " + location.name;
        }
      } else {
        const location = account.locations[0];
        if (location && location.locationNumber === locationNumber) {
          return account.name;
        }
      }
    }
    return null;
  }

  function sortField(sortingField) {
    switch (sortingField) {
      case "accDateField":
        vehicleWashList.sort(function (a, b) {
          var nameA = a.endTime;
          var nameB = b.endTime;
          if (sortingType === "accDateASC") {
            return nameA < nameB ? 1 : -1;
          } else {
            return nameA < nameB ? -1 : 1;
          }
        });
        break;
      case "accWashtypeField":
        vehicleWashList.sort(function (a, b) {
          var nameA = a.washTypeName.toUpperCase();
          var nameB = b.washTypeName.toUpperCase();
          if (sortingType === "accWashtypeASC") {
            return nameA < nameB ? 1 : -1;
          } else {
            return nameA < nameB ? -1 : 1;
          }
        });
        break;
      case "accLeadField":
        vehicleWashList.sort(function (a, b) {
          var nameA = a.leadName;
          var nameB = b.leadName;
          if (sortingType === "accLeadASC") {
            return nameA < nameB ? 1 : -1;
          } else {
            return nameA < nameB ? -1 : 1;
          }
        });
        break;
      case "accVehicleField":
        vehicleWashList.sort(function (a, b) {
          var nameA = a.vehicleNumber.toUpperCase();
          var nameB = b.vehicleNumber.toUpperCase();
          if (sortingType === "accVehicleASC") {
            return nameA < nameB ? 1 : -1;
          } else {
            return nameA < nameB ? -1 : 1;
          }
        });
        break;
      case "accCustomerField":
        currentWashList.sort(function (a, b) {
          var nameA = a[0].accountName.toUpperCase();
          var nameB = b[0].accountName.toUpperCase();
          if (sortingType === "accCustomerASC") {
            return nameA < nameB ? 1 : -1;
          } else {
            return nameA < nameB ? -1 : 1;
          }
        });
        break;
      case "accFrequencyField":
        currentWashList.sort(function (a, b) {
          var nameA = a[0].invoiceFrequency.toUpperCase();
          var nameB = b[0].invoiceFrequency.toUpperCase();
          if (sortingType === "accFrequencyASC") {
            return nameA < nameB ? 1 : -1;
          } else {
            return nameA < nameB ? -1 : 1;
          }
        });
        break;
      case "accWashField":
        currentWashList.sort(function (a, b) {
          var nameA = a.length;
          var nameB = b.length;
          if (sortingType === "accWashASC") {
            return nameA < nameB ? 1 : -1;
          } else {
            return nameA < nameB ? -1 : 1;
          }
        });
        break;
      default:
        break;
    }
  }

  // const groupBy = (array, key) => {
  //     return array.reduce((result, currentValue) => {
  //         (result[currentValue[key]] = result[currentValue[key]] || []).push(
  //             currentValue
  //         );
  //         return result;
  //     }, {});
  // };
  function getVehicleListFilteredByLeadAndDate(vehicleWashList) {
    const filteredArray = vehicleWashList.filter((item) => {
      const endTimeUTCDate = new Date(item.endTime).toISOString().split("T")[0];
      return endTimeUTCDate === currentUTCDate && item.leadId === user.id;
    });
    return filteredArray;
  }

  function getWashList() {
    let newList = groupBy(washInventoryList, "accountName");
    const result = Object.values(newList);
    setWashList(result);
  }

  const filterWashList = () => {
    if (isViewAllToggled) {
      setVehicleWashList(completeVehicleWashList);
    } else {
      const filteredList = getVehicleListFilteredByLeadAndDate(
        completeVehicleWashList,
      );
      setVehicleWashList(filteredList);
    }
  };

  function setWashInventoryListTable() {
    return vehicleWashList.map((obj, index) => {
      return (
        <tr key={index} className="acc-table-row">
          <td style={{ paddingTop: "15px" }}>{index + 1}</td>
          <td style={{ paddingTop: "15px" }}>{obj.washTypeName}</td>
          <td style={{ paddingTop: "15px" }}>{obj.leadName}</td>
          <td style={{ paddingTop: "15px" }}>{obj.vehicleNumber}</td>
          <td style={{ paddingTop: "15px" }}>{formatDate(obj.startTime)}</td>
          <td style={{ paddingTop: "15px" }}>
            {obj.washApprovedId === null ||
            obj.washApprovedId === undefined ||
            obj.washApprovedId === 0
              ? "No"
              : "Yes"}
          </td>
          <td style={{ paddingTop: "15px" }}>
            <img
              src={obj.id ? synced : syncIconForTable}
              alt={"sync-icon"}
              onClick={() => {}}
            />
          </td>
        </tr>
      );
    });
  }

  function setApproveButtonFunction(obj) {
    for (let i = 0; i < obj.length; i++) {
      if (
        obj[i].washApprovedId === null ||
        obj[i].washApprovedId === undefined ||
        obj[i].washApprovedId === 0
      ) {
        setisDisabledApprovedButton(false);
        break;
      }
    }
  }

  function setWashListTable() {
    let count = 0;
    return currentWashList.map((data, index) => {
      const groupedData = groupByLocationNumber(data);
      return groupedData.map((obj, index) => {
        const accountName = getAccountName(
          obj[0].accountId,
          obj[0].locationNumber,
        );
        count = count + 1;
        return (
          <tr key={index} className="acc-table-row">
            <td style={{ paddingTop: "15px" }}>{count}</td>
            <td style={{ paddingTop: "15px" }}>{accountName}</td>
            <td style={{ paddingTop: "15px" }}>{obj[0].invoiceFrequency}</td>
            <td style={{ paddingTop: "15px" }}>{obj.length}</td>
            <td style={{ paddingTop: "15px" }}>
              <img
                src={arrow}
                alt={"arrow-icon"}
                onClick={() => {
                  setCustomerName(accountName);
                  setCompleteVehicleWashList(obj);
                  const filteredList = getVehicleListFilteredByLeadAndDate(obj);
                  setVehicleWashList(filteredList);
                  setApproveButtonFunction(obj);
                  setShowWashInventoryList(true);
                  setSelectedObj(obj[0]);
                  setShowApprovedButton(true);
                }}
              />
            </td>
          </tr>
        );
      });
    });
  }
  function tableFieldsHeading(labelName, fieldName) {
    return (
      <div className="table-fields-heading">
        <label className="table-fields-labels">{labelName}</label>
        {fieldName === null ? null : (
          <div className="sorting-div">
            <Image
              src={asc}
              className="sorting-btns"
              style={{ cursor: "pointer" }}
              onClick={() => (
                setSortingType(fieldName + "ASC"),
                sortField(fieldName + "Field")
              )}
            ></Image>
            <Image
              src={desc}
              className="sorting-btns"
              style={{ cursor: "pointer" }}
              onClick={() => (
                setSortingType(fieldName + "DSC"),
                sortField(fieldName + "Field")
              )}
            ></Image>
          </div>
        )}
      </div>
    );
  }

  return (
    <Container>
      <Row className="button-position">
        <Button
          className="button-width"
          onClick={() => {
            navigate("/wash-inventory");
          }}
          variant="primary"
        >
          {t("washInventory.label")}
        </Button>
        <Button
          className="button-width"
          onClick={() => {
            navigate("/sync");
          }}
          variant="primary"
        >
          {t("syncButton.label")}
        </Button>

        {showApproveButton && (
          <Button
            className="button-width"
            onClick={handleShowSignatureModal}
            variant="primary"
            disabled={isDisabledApproveButton}
          >
            {t("signatureButton.label")}
          </Button>
        )}
      </Row>
      <Row
        style={{
          marginTop: "2%",
          display: showWashInventoryList ? "none" : "block",
        }}
      >
        <Form>
          <Table className="table">
            <thead>
              <tr className="table-heading">
                <th>#</th>
                <th>{tableFieldsHeading("Customer", "accCustomer")}</th>
                <th>{tableFieldsHeading("Wash Frequency", "accFrequency")}</th>
                <th>{tableFieldsHeading("Number of Washes", "accWash")}</th>
                <th>{tableFieldsHeading(" ", null)}</th>
              </tr>
            </thead>
            <tbody>
              {washList.length > 0 ? (
                setWashListTable()
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center" }}>
                    {loading ? <Loader loading={loading} /> : "No data found"}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Form>
      </Row>
      <Row
        style={{
          marginTop: "2%",
          display: showWashInventoryList ? "block" : "none",
        }}
      >
        <Row style={{ paddingRight: "0px", paddingLeft: "25px" }}>
          <Col sm="7" style={{ padding: "15px 5px" }}>
            <div
              onClick={() => {
                setIsViewAllToggled(false);
                setShowWashInventoryList(false);
                setShowApprovedButton(false);
              }}
            >
              <img
                className="back-arrow"
                src={reverseArrow}
                alt={"arrow-icon"}
              />
              <span className="back-tag">Back</span>/{customerName}
            </div>
          </Col>
          <Col
            sm="5"
            style={{ padding: "15px 5px", direction: "rtl", display: "flex" }}
          >
            <Form.Check
              type="switch"
              id="filter-by-date"
              label={t("viewAllWashes.label")}
              checked={isViewAllToggled}
              onChange={() => {
                setIsViewAllToggled(!isViewAllToggled);
              }}
            />
          </Col>
        </Row>
        <Form style={{ overflowX: "scroll" }}>
          <Table className="table">
            <thead>
              <tr className="table-heading">
                <th>#</th>
                <th>{tableFieldsHeading("Wash Type", "accWashtype")}</th>
                <th>{tableFieldsHeading("Lead #", "accLead")}</th>
                <th>{tableFieldsHeading("Vehicle #", "accVehicle")}</th>
                <th>{tableFieldsHeading("Date #", "accDate")}</th>
                <th>{tableFieldsHeading("Verified", null)}</th>
                <th>{tableFieldsHeading("Sync", null)}</th>
              </tr>
            </thead>
            <tbody>
              {washList.length > 0 ? (
                setWashInventoryListTable()
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center" }}>
                    {loading ? <Loader loading={loading} /> : "No data found"}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Form>
      </Row>
      <Row style={{ marginBottom: "15%", zIndex: "0" }}>
        {washList.length > 0 && isLoadPagination ? (
          <Pagination
            items={washList}
            currentItems={setCurrentWashList}
            itemsPerpage={itemsPerpage}
            itemOffset={setItemOffset}
            endOffset={setEndOffset}
            clearSelectedItems={setSelectedItems}
          />
        ) : null}
      </Row>
      {/* signature capture model */}
      <Modal show={showSignatureModal} onHide={handleCloseSignatureModal}>
        <Modal.Header closeButton>
          <Modal.Title>{t("signatureModelHeading.label")}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Form style={{ width: "100%" }}>
            <Form.Check
              type="switch"
              id="custom-switch"
              label="Is Fleet Manager Available ?"
              value={fleetManagerAvailable}
              onChange={() => {
                setFleetManagerAvailable((prev) => !prev);
              }}
            />
          </Form>

          {fleetManagerAvailable ? (
            <>
              <div style={{ marginTop: "20px" }}>
                <h6>Enter Name</h6>
                <Form.Control
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <h6 style={{ marginTop: "10px" }}>Draw your signature</h6>
                <SignaturePad
                  ref={canvas}
                  canvasProps={{
                    className: "sigCanvas",
                    width: "auto",
                    height: "400px",
                  }}
                />
              </div>
            </>
          ) : (
            <>
              <Alert variant="dark" style={{ marginTop: "20px" }}>
                If the fleet manager is not available, the lead can approve the
                wash list.
              </Alert>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {fleetManagerAvailable && (
            <Button variant="secondary" onClick={clear}>
              {t("clear.label")}
            </Button>
          )}
          <Button variant="primary" onClick={save}>
            {t("save.label")}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default Track;
